import { useQueryClient } from "@tanstack/react-query";
import type { FrameResponseDto } from "@/api";
import {
  extractFrameImageUrls,
  fetchFrames,
  framesQueryKey,
  mapFrameResponseDtoToFrameModel,
  FRAMES_STALE_TIME,
} from "@/hooks/api/useGetFrames";
import { prefetchImages } from "@/lib/utils/imagePrefetch";

export const usePrefetchFrames = () => {
  const queryClient = useQueryClient();

  const prefetchFrames = async () => {
    await queryClient.prefetchQuery({
      queryKey: framesQueryKey,
      queryFn: fetchFrames,
      staleTime: FRAMES_STALE_TIME,
      gcTime: FRAMES_STALE_TIME,
    });
    const frames = queryClient.getQueryData<FrameResponseDto[]>(framesQueryKey);
    if (frames) {
      prefetchImages(extractFrameImageUrls(mapFrameResponseDtoToFrameModel(frames)));
    }
  };

  return { prefetchFrames };
};
